var $ = (jQuery = $);
let locale = window.Shopify.locale;

const $inp = $(".ap-otp-input");
$inp.on({
  paste(ev) {
    // Handle Pasting

    const clip = ev.originalEvent.clipboardData.getData("text").trim();
    // Allow numbers only
    if (!/\d{6}/.test(clip)) return ev.preventDefault(); // Invalid. Exit here
    // Split string to Array or characters
    const s = [...clip];
    // Populate inputs. Focus last input.
    $inp
      .val((i) => s[i])
      .eq(5)
      .focus();
  },
  input(ev) {
    // Handle typing

    const i = $inp.index(this);
    if (this.value) $inp.eq(i + 1).focus();
    // console.log(this.value);
  },
  keydown(ev) {
    // Handle Deleting

    const i = $inp.index(this);
    if (!this.value && ev.key === "Backspace" && i) $inp.eq(i - 1).focus();
  },
});

function SignUpReload() {
  const current_url = new URLSearchParams(window.location.search);
  var cus_phone = current_url.get("phone").trim();
  if (phone){
    country_code = '+' + cus_phone.slice(0, 2);
    phone = cus_phone.slice(2);
    $(".iti__selected-dial-code")[0].innerText = country_code;
    $("#phone").val(phone);
    $("#send_otp").click();
  }
}

let sec = 60;
let countdown = null;

// const updateButton = () => {
//   cooldown_span = document.querySelector("#otp_cooldown");
//   if (locale == "th") {
//     cooldown_span.innerHTML = `ยังไม่ได้รับรหัส OTP? โปรดลองอีกครั้งใน ${sec} วินาที`;
//   } else {
//     cooldown_span.innerHTML = `Haven’t got OTP? Try again in ${sec} sec`;
//   }
//   button = document.querySelector("#resend_otp");
//   $("#resend_otp").css("display", "none");
//   button.disabled = true;
//   if (sec === 0) {
//     clearInterval(countdown);
//     sec = 120;
//     // todo display resend otp button and hide cooldown
//     $("#resend_otp").css("display", "block");
//     button.disabled = false;
//     return;
//   }
//   sec--;
// };

const updateButton = () => {
  const $cooldown = $("#otp_cooldown");
  const $button   = $("#resend_otp");
  $cooldown.show()

  if (locale == "th") {
    $cooldown.html(`ยังไม่ได้รับรหัส OTP? โปรดลองอีกครั้งใน ${sec} วินาที`);
  } else {
    $cooldown.html(`Haven’t got OTP? Try again in ${sec} seconds`);
  }

  $button.hide().prop("disabled", true);

  if (sec === 0) {
    clearInterval(countdown);
    sec = 60;

    // Hiện resend OTP và ẩn cooldown
    $cooldown.hide();
    $button.show().prop("disabled", false);

    return;
  }

  sec--;
};


function formatPhoneNumber(phoneNumber) {
  phoneNumber = phoneNumber.startsWith("+")
    ? phoneNumber.substring(1)
    : phoneNumber;
  return (
    "+" +
    phoneNumber.slice(0, 2) +
    "-" +
    phoneNumber.slice(2, 5) +
    "-" +
    phoneNumber.slice(5, 8) +
    "-" +
    phoneNumber.slice(8)
  );
}

function disableButtonById(id) {
  let $btn = $(`#${id}`);
  // Disable
  $btn.prop("disabled", true);
  // Thêm icon loading nếu chưa có
  if ($btn.find("i.fa-refresh").length === 0) {
    $btn.prepend('<i class="fa fa-refresh fa-spin"></i> ');
  }
}

function enableButtonById(id) {
  let $btn = $(`#${id}`);
  // Enable lại
  $btn.prop("disabled", false);
  // Xoá icon loading (nếu có)
  $btn.find("i.fa-refresh").remove();
}

function sendOTPNew() {
  var check_input = 1;
  if ($("#phone").val().length === 0) {
    $("#phone").css("border-color", "red");
    $(".input-error-phone").css("display", "block");
    check_input = 0;
  } else {
    $("#phone").css("border-color", "#c9c9c9");
    $(".input-error-phone").css("display", "none");
  }

  if (check_input == 1) {
    disableButtonById("send_otp");
    var phone =
      $(".iti__selected-dial-code")[0].innerText +
      $("#phone").val().replace(/ /g, "");
    var settings = {
      url: "https://apishopify.gqsize.com/supara/send_otp",
      method: "POST",
      timeout: 0,
      headers: {
        "Content-Type": "application/json",
      },
      data: JSON.stringify({
        phone: phone,
        language: window.Shopify.locale,
      }),
    };
    $.ajax(settings).done(function (response) {
      // console.log(response);
      if (response.code !== 500) {
        // updateButton();
        countdown = setInterval(function () {
          updateButton();
        }, 1000);
        $(".input-row-phone").css("display", "none");
        $(".have_account").css("display", "none");
        $(".ap-otp-input").css("display", "inline");
        $("#otp_cooldown").css("display", "inline");
        $("#resend_otp").css("display", "none");
        $("#otp_header").css("display", "block");
        $("#otp_header2").css("display", "block");
        $("#create_header").css("display", "none");
        $("#have_account").css("display", "none");
        $(".sent-opt-text").css("display", "block");
        var sent_phone = $("#phone").val();
        if ($("#phone").val()[0] != "0") {
          sent_phone = formatPhoneNumber(
            $(".iti__selected-dial-code")[0].innerText +
              $("#phone").val().replace(/ /g, "")
          );
        }
        document.getElementById("otp-sent-phone").innerText = sent_phone;
        $("#send_otp").css("display", "none");
        $(".existed-phone-error").css("display", "none");
        $("#verify_otp").css("display", "inline");
        // console.log("ok");
      } else if (response.code == 300) {
        alert(response.message);
        enableButtonById("send_otp");
      } else {
        alert(response.message);
        enableButtonById("send_otp");
      }
    });
  }
}

function verifyOTPNew() {
  disableButtonById("verify_otp");
  var phone =
    $(".iti__selected-dial-code")[0].innerText +
    $("#phone").val().replace(/ /g, "");
  var otp_code = "";
  if (
    $("#ap-otp-input1").val().length > 0 &&
    $("#ap-otp-input2").val().length > 0 &&
    $("#ap-otp-input3").val().length > 0 &&
    $("#ap-otp-input4").val().length > 0 &&
    $("#ap-otp-input5").val().length > 0 &&
    $("#ap-otp-input6").val().length > 0
  ) {
    otp_code =
      $("#ap-otp-input1").val() +
      $("#ap-otp-input2").val() +
      $("#ap-otp-input3").val() +
      $("#ap-otp-input4").val() +
      $("#ap-otp-input5").val() +
      $("#ap-otp-input6").val();
    // console.log(otp_code);
  }
  var settings2 = {
    url: "https://apishopify.gqsize.com/supara/verify_otp_login",
    method: "POST",
    timeout: 0,
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify({
      phone: phone,
      code: otp_code,
    }),
  };
  $.ajax(settings2).done(function (response) {
    // console.log(response);
    if(response.code == 200 || response.code == 300 || response.code == 400){
      const $cooldown = $("#otp_cooldown");
      const $button   = $("#resend_otp");
      clearInterval(countdown);
      $cooldown.hide();
      $button.hide().prop("disabled", true);
    }
    if (response.code == 200) {
      if (response.email) {
        if (response.email.includes("@testgq.com") || response.email.includes("dummy")) {
          $(".ap-otp-input").css("display", "none");
          $("#otp_cooldown").css("display", "none");
          $("#resend_otp").css("display", "none");
          $("#otp_header").css("display", "none");
          $("#otp_header2").css("display", "none");
          $("#verify_otp").css("display", "none");
          $(".sent-opt-text").css("display", "none");
          $(".confirm_email_pw_div").css("display", "block");
          $("#update_email_pw").css("display", "block");
        } else {
          var myHeaders = new Headers();
          myHeaders.append("Content-Type", "application/json");

          var raw = JSON.stringify({
            customer: {
              email: response.email,
              password: "12345678",
            },
          });

          var requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow",
          };

          fetch(
            "https://gqsize.com/account/login?return_url=/account",
            requestOptions
          )
            .then((response) => response.text())
            .then((result) => {
              const locale = window.Shopify.locale;
              if (locale != "th") {
                window.location.href = "/" + locale + "/account";
              } else {
                window.location.href = "/account";
              }
            });
        }
      } else {
        if (response.email == null) {
          $(".ap-otp-input").css("display", "none");
          $("#otp_cooldown").css("display", "none");
          $("#resend_otp").css("display", "none");
          $("#otp_header").css("display", "none");
          $("#otp_header2").css("display", "none");
          $("#verify_otp").css("display", "none");
          $(".sent-opt-text").css("display", "none");
          $(".confirm_email_pw_div").css("display", "block");
          $("#update_email_pw").css("display", "block");
        } else {
          $(".input-row").css("display", "block");
          $(".input-row-phone").css("display", "block");
          document.getElementById("phone").disabled = true;
          $(".ap-otp-input").css("display", "none");
          $("#otp_cooldown").css("display", "none");
          $("#resend_otp").css("display", "none");
          $("#otp_header").css("display", "none");
          $("#otp_header2").css("display", "none");
          $("#verify_otp").css("display", "none");
          $(".sent-opt-text").css("display", "none");
          $("#send_otp_3").css("display", "inline");
        }
      }
    } else if (response.code == 400){
        $(".input-row").css("display", "block");
        $(".input-row-phone").css("display", "block");
        // $("#email").val(response.email);
        if(response.email){
            if (!response.email.includes("@testgq.com") && !response.email.includes("dummy")) {
              $("#email").val(response.email);
            }
          }
        if(response.name){
          $("#first_name").val(response.name);
        }
        if(response.dob){
          $("#birthday").val(response.dob);
          document.getElementById("birthday").disabled = true;

        }
        if(response.gender){
          if(response.gender == 'Male'){
              document.getElementById("gender_male").checked = true;
          } else if (response.gender == 'Female'){
            document.getElementById("gender_female").checked = true;
          } else if (response.gender == 'Neutral'){
            document.getElementById("gender_neutral").checked = true;
          }
          
        }
        document.getElementById("phone").disabled = true;
        $(".ap-otp-input").css("display", "none");
        $("#otp_cooldown").css("display", "none");
        $("#resend_otp").css("display", "none");
        $("#otp_header").css("display", "none");
        $("#otp_header2").css("display", "none");
        $("#verify_otp").css("display", "none");
        $(".sent-opt-text").css("display", "none");
        $("#updateGenderBoD").css("display", "inline");
    }  else if (response.code == 300){
          
          if(response.email){
            if (!response.email.includes("@testgq.com") && !response.email.includes("dummy")) {
              $("#email").val(response.email);
            }
          }
          if(response.name){
              $("#first_name").val(response.name);
            }
          if(response.dob){
            $("#birthday").val(response.dob);
            document.getElementById("birthday").disabled = true;

          }
          if(response.gender){
            if(response.gender == 'Male' || response.gender == 'ชาย'){
                document.getElementById("gender_male").checked = true;
            } else if (response.gender == 'Female' || response.gender == 'หญิง'){
              document.getElementById("gender_female").checked = true;
            } else if (response.gender == 'Neutral' || response.gender == 'ไม่ระบุ'){
              document.getElementById("gender_neutral").checked = true;
            }
            
          }
          $(".input-row").css("display", "block");
          $(".input-row-phone").css("display", "block");
          document.getElementById("phone").disabled = true;
          $(".ap-otp-input").css("display", "none");
          $("#otp_cooldown").css("display", "none");
          $("#resend_otp").css("display", "none");
          $("#otp_header").css("display", "none");
          $("#otp_header2").css("display", "none");
          $("#verify_otp").css("display", "none");
          $(".sent-opt-text").css("display", "none");
          $("#send_otp_3").css("display", "inline");
    } 
    else {
      alert(response.error);
      enableButtonById("verify_otp")
    }
  });
}

function updateGenderBoD(base_url) {
  let hasError = false;
  let firstName = $("#first_name").val().trim();
  let email = $("#email").val().trim();
  let birthday = $("#birthday").val();

  if (firstName === "") {
    $(".input-error-fname").show();
    hasError = true;
  }

  if (email === "") {
    $(".input-error-email").show();
    hasError = true;
  }

  if (birthday === "") {
    $(".input-error-birthday").show();
    hasError = true;
  }

  if ($("input[name='Cgender']:checked").length === 0) {
    $(".input-error-gender").show();
    hasError = true;
  }

  if (!$("input#marketing").is(":checked")) {
    $("span.input-error-terms").show();
    hasError = true;
  }
  
  if (hasError) {
    return;
  }


  var phone =
    $(".iti__selected-dial-code")[0].innerText +
    $("#phone").val().replace(/ /g, "");
  var gender = "";
  var radios = document.getElementsByName("Cgender");
  for (var i = 0, length = radios.length; i < length; i++) {
    if (radios[i].checked) {
      gender = radios[i].value;
      break;
    }
  }
  var settings2 = {
    url: "https://apishopify.gqsize.com/supara/update_customer_dg",
    method: "POST",
    timeout: 0,
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify({
      name: $("#first_name").val(),
      email: $("#email").val(),
      phone: phone,
      dob: $("#birthday").val(),
      gender: gender,
    }),
  };
  $.ajax(settings2).done(function (response) {
    // console.log(response);
    if (response.code == 200) {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      var raw = JSON.stringify({
        customer: {
          email: $("#email").val(),
          password: "12345678",
        },
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      fetch(base_url + "/account/login?return_url=/account", requestOptions)
        .then((response) => response.text())
        .then((result) => {
          const locale = window.Shopify.locale;
          if (locale != "th") {
            window.location.href = "/" + locale + "/account";
          } else {
            window.location.href = "/account";
          }
        });
    } else {
      alert(response.error);
    }
  });
}

function registerNew(base_url) {
  let hasError = false;
  let firstName = $("#first_name").val().trim();
  let email = $("#email").val().trim();
  let birthday = $("#birthday").val();

  if (firstName === "") {
    $(".input-error-fname").show();
    hasError = true;
  }

  if (email === "") {
    $(".input-error-email").show();
    hasError = true;
  }

  if (birthday === "") {
    $(".input-error-birthday").show();
    hasError = true;
  }

  if ($("input[name='Cgender']:checked").length === 0) {
    $(".input-error-gender").show();
    hasError = true;
  }

  if (!$("input#marketing").is(":checked")) {
    $("span.input-error-terms").show();
    hasError = true;
  }
  
  if (hasError) {
    return;
  }

  disableButtonById("send_otp_3");


  var phone =
    $(".iti__selected-dial-code")[0].innerText +
    $("#phone").val().replace(/ /g, "");
  var gender = "";
  var radios = document.getElementsByName("Cgender");
  for (var i = 0, length = radios.length; i < length; i++) {
    if (radios[i].checked) {
      gender = radios[i].value;
      break;
    }
  }
  var settings2 = {
    url: "https://apishopify.gqsize.com/supara/register_member?name=" + $("#first_name").val() 
      + "&email=" + $("#email").val() 
      + "&phone=" + phone 
      + "&dob=" + $("#birthday").val() 
      + "&gender=" + gender // bỏ comment nhớ bỏ dấu phẩy
      + "&utm_called_from=regular",
    method: "POST",
    timeout: 0,
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify({
      name: $("#first_name").val(),
      email: $("#email").val(),
      phone: phone,
      dob: $("#birthday").val(),
      gender: gender, // bỏ comment nhớ thêm dấu phẩy
      utm_called_from: 'regular'
    }),
  };
  $.ajax(settings2).done(function (response) {
    // console.log(response);
    if (response.code == 200) {
      if (response.activate_url) {
        window.location.href = response.activate_url;
      }
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      var raw = JSON.stringify({
        customer: {
          email: $("#email").val(),
          password: "12345678",
        },
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      fetch("https://gqsize.com" + "/account/login?return_url=/account", requestOptions)
        .then((response) => response.text())
        .then((result) => {
          const locale = window.Shopify.locale;
          if (locale != "th") {
            window.location.href = "/" + locale + "/account";
          } else {
            window.location.href = "/account";
          }
        });
    } else {
      alert(response.error);
      enableButtonById("send_otp_3")
    }
  });
}

function resendOTP() {
  var phone =
    $(".iti__selected-dial-code")[0].innerText +
    $("#phone").val().replace(/ /g, "");
  var settings = {
    url: "https://apishopify.gqsize.com/supara/resend_otp",
    method: "POST",
    timeout: 0,
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify({
      phone: phone,
      language: window.Shopify.locale,
    }),
  };
  $.ajax(settings).done(function (response) {
    if (response.code == 200) {
      countdown = setInterval(function () {
        updateButton();
      }, 1000);
      $("#ap-otp-input1").val('');
      $("#ap-otp-input2").val('');
      $("#ap-otp-input3").val('');
      $("#ap-otp-input4").val('');
      $("#ap-otp-input5").val('');
      $("#ap-otp-input6").val('');
      $("#resend_otp").css("display", "none");
    } else {
      alert(response.error);
    }
  });
}

function sendOTP() {
  var check_input = 1;
  if ($("#first_name").val().length === 0) {
    $("#first_name").css("border-color", "red");
    $(".input-error-fname").css("display", "block");
    check_input = 0;
  } else {
    $("#first_name").css("border-color", "#c9c9c9");
    $(".input-error-fname").css("display", "none");
  }
  if ($("#last_name").val().length === 0) {
    $("#last_name").css("border-color", "red");
    $(".input-error-lname").css("display", "block");
    check_input = 0;
  } else {
    $("#last_name").css("border-color", "#c9c9c9");
    $(".input-error-lname").css("display", "none");
  }
  if ($("#email").val().length === 0) {
    $("#email").css("border-color", "red");
    $(".input-error-email").css("display", "block");
    check_input = 0;
  } else {
    $("#email").css("border-color", "#c9c9c9");
    $(".input-error-email").css("display", "none");
  }
  if ($("#phone").val().length === 0) {
    $("#phone").css("border-color", "red");
    $(".input-error-phone").css("display", "block");
    check_input = 0;
  } else {
    $("#phone").css("border-color", "#c9c9c9");
    $(".input-error-phone").css("display", "none");
  }
  if ($("#password").val().length === 0) {
    $("#password").css("border-color", "red");
    $(".input-error-pw").css("display", "block");
    check_input = 0;
  } else {
    $("#password").css("border-color", "#c9c9c9");
    $(".input-error-pw").css("display", "none");
  }
  if ($("#password").val().length < 8) {
    $("#password").css("border-color", "red");
    check_input = 0;
  } else {
    $("#password").css("border-color", "#c9c9c9");
  }
  if ($("#marketing").is(":checked") == false) {
    $(".marketing-error").css("display", "block");
    check_input = 0;
  } else {
    $(".marketing-error").css("display", "none");
  }
  if (check_input == 1) {
    var phone =
      $(".iti__selected-dial-code")[0].innerText +
      $("#phone").val().replace(/ /g, "");
    var settings = {
      url: "https://apishopify.gqsize.com/supara/send_otp",
      method: "POST",
      timeout: 0,
      headers: {
        "Content-Type": "application/json",
      },
      data: JSON.stringify({
        first_name: $("#first_name").val(),
        last_name: $("#last_name").val(),
        email: $("#email").val(),
        password: $("#password").val(),
        password_confirmation: $("#password").val(),
        phone: phone,
        referal_code: $("#referal").val(),
        language: window.Shopify.locale,
      }),
    };
    $.ajax(settings).done(function (response) {
      // console.log(response);
      if (response.code !== 500) {
        // updateButton();
        countdown = setInterval(function () {
          updateButton();
        }, 1000);
        $(".input-row").css("display", "none");
        $(".have_account").css("display", "none");
        $(".ap-otp-input").css("display", "inline");
        $("#otp_cooldown").css("display", "inline");
        $("#resend_otp").css("display", "inline");
        $("#otp_header").css("display", "block");
        $("#otp_header2").css("display", "block");
        $("#create_header").css("display", "none");
        $("#have_account").css("display", "none");
        $(".sent-opt-text").css("display", "block");
        var sent_phone = $("#phone").val();
        if ($("#phone").val()[0] != "0") {
          sent_phone = formatPhoneNumber(
            $(".iti__selected-dial-code")[0].innerText +
              $("#phone").val().replace(/ /g, "")
          );
        }
        document.getElementById("otp-sent-phone").innerText = sent_phone;
        $("#send_otp").css("display", "none");
        $(".existed-email-error").css("display", "none");
        $(".existed-phone-error").css("display", "none");
        $("#send_otp_3").css("display", "inline");
        // console.log("ok");
      } else if (response.code == 300) {
        alert(response.message);
      } else {
        alert(response.message);
      }
    });
  }
}
$("#show_password").on("click", function () {
  var x = document.getElementById("password");
  if (x.type === "password") {
    x.type = "text";
  } else {
    x.type = "password";
  }
});

function sendOTP2() {
  var phone =
    $(".iti__selected-dial-code")[0].innerText +
    $("#phone").val().replace(/ /g, "");
  var settings = {
    url: "https://apishopify.gqsize.com/supara/send_otp",
    method: "POST",
    timeout: 0,
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify({
      first_name: $("#first_name").val(),
      last_name: $("#last_name").val(),
      email: $("#email").val(),
      password: $("#password").val(),
      password_confirmation: $("#password").val(),
      phone: phone,
      language: window.Shopify.locale,
    }),
  };
  $.ajax(settings).done(function (response) {
    // console.log(response);
    if (response.code == 200) {
      // console.log("ok");
    } else if (response.code == 300) {
      alert(response.message);
    } else {
      alert(response.message);
    }
  });
}

function sendOTP3(base_url) {
  var phone =
    $(".iti__selected-dial-code")[0].innerText +
    $("#phone").val().replace(/ /g, "");
  var otp_code = "";
  if (
    $("#ap-otp-input1").val().length > 0 &&
    $("#ap-otp-input2").val().length > 0 &&
    $("#ap-otp-input3").val().length > 0 &&
    $("#ap-otp-input4").val().length > 0 &&
    $("#ap-otp-input5").val().length > 0 &&
    $("#ap-otp-input6").val().length > 0
  ) {
    otp_code =
      $("#ap-otp-input1").val() +
      $("#ap-otp-input2").val() +
      $("#ap-otp-input3").val() +
      $("#ap-otp-input4").val() +
      $("#ap-otp-input5").val() +
      $("#ap-otp-input6").val();
    // console.log(otp_code);
  }
  var settings2 = {
    url: "https://apishopify.gqsize.com/supara/verify_otp",
    method: "POST",
    timeout: 0,
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify({
      first_name: $("#first_name").val(),
      last_name: $("#last_name").val(),
      email: $("#email").val(),
      password: $("#password").val(),
      password_confirmation: $("#password").val(),
      phone: phone,
      referal_code: $("#referal").val(),
      code: otp_code,
    }),
  };
  $.ajax(settings2).done(function (response) {
    // console.log(response);
    if (response.code == 200) {
      // todo đoạn báo thành công và login khách vào
      function ajaxLoginShopify() {
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify({
          customer: {
            email: $("#email").val(),
            password: $("#password").val(),
          },
        });

        var requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: raw,
          redirect: "follow",
        };

        fetch(base_url + "/account/login?return_url=/account", requestOptions)
          .then((response) => response.text())
          .then((result) => {
            if (result.includes("supara_welcome-title")) {
              // window.location.href = "/pages/membership-welcome2";
              const locale = window.Shopify.locale;
              if (locale != "th") {
                window.location.href = "/" + locale + "/account";
              } else {
                window.location.href = "/account";
              }
            } else {
              document.querySelector("#create_user").click();
            }
          })
          .catch((error) => console.log("error", error));
        // console.log("2222");
        // fetch(base_url + "/account/login", {
        //   method: "POST",
        //   headers: {
        //     "Content-Type": "application/x-www-form-urlencoded",
        //   },
        //   body:
        //     "form_type=customer_login&utf8=✓&customer[email]=" +
        //     encodeURIComponent($("#email").val()) +
        //     "&customer[password]=" +
        //     encodeURIComponent($("#password").val()),
        // })
        //   .then((response) => {
        //     console.log(response);
        //     if (response.ok) {
        //       window.location.href = base_url; // Redirect to a specific page after login
        //     } else {
        //       alert("Login failed!");
        //     }
        //   })
        //   .catch((error) => console.error("Error:", error));
      }
      ajaxLoginShopify();
      // console.log("ok");
    } else if (response.code == 300) {
      // todo đoạn này hiện lỗi và làm nút  để quay lại màn hình đăng ký do code 300 là code email và số điện thoại sai
      if (response.error == "email has already been taken") {
        register_fail();
        $(".existed-email-error").css("display", "block");
      } else if (response.error == "Phone has already been taken") {
        register_fail();
        $(".existed-phone-error").css("display", "block");
      } else if (response.error == "email is invalid") {
        register_fail();
        $(".invalid-email-error").css("display", "block");
      } else if (response.error == "Enter a valid phone number") {
        register_fail();
        $(".invalid-phone-error").css("display", "block");
      } else if (response.error == "Invalid OTP") {
        $(".invalid-otp").css("display", "block");
      }
    } else {
      register_fail();
      $(".system-error").css("display", "block");
    }
  });
}

function updateEmailPw(base_url) {
  if ($("#confirm_email").val().length === 0) {
    alert("Please input your email");
  }
  var email = $("#confirm_email").val();

  var phone =
    $(".iti__selected-dial-code")[0].innerText +
    $("#phone").val().replace(/ /g, "");
  if (email){
    var settings = {
    url: "https://apishopify.gqsize.com/supara/update_email_pw",
    method: "POST",
    timeout: 0,
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify({
      phone: phone,
      email: email,
      password: "12345678",
    }),
  };
  $.ajax(settings).done(function (response) {
    if (response.code == 200) {
      if (response.email.includes('/activate')) {
          window.location.href = response.email;
      }
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      var raw = JSON.stringify({
        customer: {
          email: email,
          password: "12345678",
        },
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      fetch(base_url + "/account/login?return_url=/account", requestOptions)
        .then((response) => response.text())
        .then((result) => {
          const locale = window.Shopify.locale;
          if (locale != "th") {
            window.location.href = "/" + locale + "/account";
          } else {
            window.location.href = "/account";
          }
        });
    } else {
      alert(response.error);
    }
  });
  // }
  }
  
}

function register_fail() {
  $(".input-row").css("display", "block");
  $(".have_account").css("display", "block");
  $(".ap-otp-input").css("display", "none");
  $("#otp_cooldown").css("display", "none");
  $("#resend_otp").css("display", "none");
  $("#otp_header").css("display", "none");
  $("#otp_header2").css("display", "none");
  $("#create_header").css("display", "block");
  $("#have_account").css("display", "block");
  $("#send_otp").css("display", "block");
  $("#send_otp_3").css("display", "none");
  $(".sent-opt-text").css("display", "none");
}

$(document).keypress(function(event){
    if (event.which == 13) {
        event.preventDefault();
        var btn = $("div.wide-action button:visible:not(#resend_otp)").first();
        btn.click();
    }
});


// ẩn các error khi bắt đầu nhập dữ liệu
$("#first_name").on("input", function () {
  if ($(this).val().trim() !== "") {
    $(".input-error-fname").hide();
  }
});

$("#email").on("input", function () {
  if ($(this).val().trim() !== "") {
    $(".input-error-email").hide();
  }
});

$("#birthday").on("input", function () {
  if ($(this).val() !== "") {
    $(".input-error-birthday").hide();
  }
});

$("input[name='Cgender']").on("change", function () {
  if ($("input[name='Cgender']:checked").length > 0) {
    $(".input-error-gender").hide();
  }
});

$("input#marketing").on("change", function () {
  if ($(this).is(":checked")) {
      $(".input-error-terms").hide();
    }
});

